import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchBusinessTypes, createBusinessType, fetchBusinessType, modifyBusinessType, deleteBusinessTypeApi, changeStatus } from '../../api/businessTypeApi';

export const getBusinessTypes = createAsyncThunk('businessType/getBusinessTypes', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchBusinessTypes(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addBusinessType = createAsyncThunk('businessType/addBusinessType', async (payload, { rejectWithValue }) => {
  try {
    const response = await createBusinessType(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getBusinessTypeDetails = createAsyncThunk('businessType/getBusinessTypeDetails', async (businessTypeId, { rejectWithValue }) => {
  try {
    const response = await fetchBusinessType(businessTypeId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateBusinessType = createAsyncThunk('businessType/updateBusinessType', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyBusinessType(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteBusinessType = createAsyncThunk('businessType/deleteBusinessType', async (businessTypeId, { rejectWithValue }) => {
  try {
    const response = await deleteBusinessTypeApi(businessTypeId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('businessType/changeDefaultStatus', async (businessTypeId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(businessTypeId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const businessTypeSlice = createSlice({
  name: 'businessType',
  initialState: {
    businessTypes: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBusinessTypes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getBusinessTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.businessTypes = action.payload;
      })
      .addCase(getBusinessTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default businessTypeSlice.reducer;
